<template>
  <div class="col-lg-12" style="padding: 20px">
    <div class="main-card mb-3 card" style="margin-left: 10px">
      <div class="card-body">
        <h5 class="card-title">
          팝업 관리
          <div
            class="sub_title"
            style="
              margin-bottom: 20px;
              color: #333;
              font-size: 13px;
              border: 1px solid #ccc;
              background: #f8f8f8;
              height: 30px;
              text-align: right;
              position: absolute;
              right: 20px;
              top: 10px;
              padding: 2px 10px;
            "
          >
            사이트 관리 → 팝업 관리
          </div>
        </h5>
        <query-grid :config="config" ref="qg">
          <template #actions>
            <button
              class="btn btn-danger"
              data-bs-toggle="modal"
              data-bs-target=".bd-example-modal-lg"
              @click="creating()"
            >
              팝업 생성
            </button>
          </template>
          <template #items="props">
            <tr v-for="record in props.records" v-bind:key="record.id">
              <td style="padding: 15px 0">{{ record.id }}</td>
              <td>{{ record.title }}</td>
              <td>
                <template v-if="record.show_in_pchome == 1">PC홈 </template>
                <template v-if="record.show_in_mobilehome == 1"
                  >모바일홈
                </template>
                <template v-if="record.show_in_usersite == 1">하부홈 </template>
                <template v-if="record.show_in_study == 1">학습관 </template>
                <template v-if="record.show_in_intro == 1">인트로 </template>
                <template v-if="record.show_in_lms == 1">LMS </template>
              </td>
              <td>{{ record.size_width }}</td>
              <td>{{ record.size_height }}</td>
              <td>{{ record.start_date }}</td>
              <td>{{ record.end_date }}</td>
              <td>
                <template v-if="record.active == 1">사용</template>
                <template v-else>미사용</template>
              </td>
              <td>{{ record.target }}</td>
              <td>{{ record.created_at }}</td>
              <td>
                <button
                  class="btn btn-secondary btn-sm"
                  style="padding: 2px 4px; font-size: 12px"
                  v-on:click="loadPopup(record.id)"
                  data-bs-toggle="modal"
                  data-bs-target=".bd-example-modal-lg"
                >
                  수정
                </button>
              </td>
            </tr>
          </template>
        </query-grid>

        <!-- Large modal -->

        <div
          class="modal fade bd-example-modal-lg"
          tabindex="-1"
          role="dialog"
          aria-labelledby="myLargeModalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLongTitle">
                  팝업 관리
                </h5>
              </div>
              <div class="modal-body">
                <table class="table">
                  <tbody>
                    <tr>
                      <td class="td_bg">제목</td>
                      <td>
                        <input
                          type="text"
                          class="input"
                          v-model="selPopup.title"
                          style="width: 200px"
                        />
                      </td>
                      <td class="td_bg">표시대상</td>
                      <td>
                        <tree-btn :tree="this.$refs.biz" />
                      </td>
                    </tr>
                    <tr>
                      <td class="td_bg">위치</td>
                      <td class="tdtd" colspan="3">
                        <input
                          type="checkbox"
                          v-model="selPopup.show_in_pchome"
                        />홈페이지(pc)&nbsp;&nbsp;&nbsp;
                        <input
                          type="checkbox"
                          v-model="selPopup.show_in_mobilehome"
                        />홈페이지(모바일) &nbsp;&nbsp;&nbsp;
                        <input
                          type="checkbox"
                          v-model="selPopup.show_in_usersite"
                        />하부홈페이지&nbsp;&nbsp;&nbsp;
                        <input
                          type="checkbox"
                          v-model="selPopup.show_in_study"
                        />학습관&nbsp;&nbsp;&nbsp;
                        <input
                          type="checkbox"
                          v-model="selPopup.show_in_intro"
                        />인트로&nbsp;&nbsp;&nbsp;
                        <input
                          type="checkbox"
                          v-model="selPopup.show_in_lms"
                        />LMS&nbsp;&nbsp;&nbsp;
                      </td>
                    </tr>
                    <tr>
                      <td class="td_bg">팝업창</td>
                      <td class="tdtd" style="height: 80px">
                        <span style="color: #008aff"
                          >가로380px 세로420px 고정</span
                        >
                      </td>
                      <td class="td_bg">노출여부</td>
                      <td class="tdtd">
                        <span class="">
                          노출<input
                            type="checkbox"
                            v-model.number="selPopup.active"
                          />
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td class="td_bg">시작일시</td>
                      <td class="tdtd">
                        <input
                          type="datetime-local"
                          class="input"
                          v-model="selPopup.start_date"
                          style="
                            border: 1px solid #eee;
                            padding: 16px 20px;
                            width: 160px;
                            background: #f0f0f0;
                            border-radius: 8px;
                          "
                        />
                      </td>
                      <td class="td_bg">종료일시</td>
                      <td class="tdtd">
                        <input
                          type="datetime-local"
                          class="input"
                          v-model="selPopup.end_date"
                          style="
                            border: 1px solid #eee;
                            padding: 16px 20px;
                            width: 160px;
                            background: #f0f0f0;
                            border-radius: 8px;
                          "
                        />
                      </td>
                    </tr>
                    <!--tr>
                      <td class="td_bg">레이어팝업</td>
                      <td class="tdtd">
                          <input type="radio" name="on"  />사용&nbsp;&nbsp;<input type="radio" name="on" />미사용
                      </td>
                      <td class="td_bg">본문타입</td>
                       <td>
                           <input type="radio" name="on"  />이미지 등록&nbsp;&nbsp;<input type="radio" name="on" />사용자 편집
                      </td>
                    </tr-->
                    <tr>
                      <td class="td_bg">이미지(200MB 이하)</td>
                      <td colspan="3">
                        <!--<input type="radio" name="on"  />사용&nbsp;&nbsp;<input type="radio" name="on" />미사용
                            <button class="">파일선택</button-->
                        <button
                          @click="uploadImage()"
                          class="btn btn-info btn-sm"
                        >
                          파일선택</button
                        ><br />
                        <img
                          v-if="selPopup.image_url"
                          :src="selPopup.image_url"
                          style="width: 250px"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td class="td_bg">연결주소</td>
                      <td class="tdtd">
                        <input
                          type="text"
                          v-model="selPopup.link_href"
                          maxlength="200"
                          style="width: 100%; ime-mode: disabled"
                        />
                      </td>
                      <td class="td_bg">연결방법</td>
                      <td>
                        <span class="">
                          <select
                            v-model="selPopup.target"
                            style="border: 1px solid #ccc; padding: 4px 6px"
                          >
                            <option value="">현재창</option>
                            <option value="_blank">새창</option>
                          </select>
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td class="td_bg">모바일 연결주소</td>
                      <td class="tdtd">
                        <input
                          type="text"
                          v-model="selPopup.m_link_href"
                          maxlength="200"
                          style="width: 100%; ime-mode: disabled"
                        />
                      </td>
                      <td class="td_bg">모바일 연결방법</td>
                      <td>
                        <span class="">
                          <select
                            v-model="selPopup.m_target"
                            style="border: 1px solid #ccc; padding: 4px 6px"
                          >
                            <option value="">현재창</option>
                            <option value="_blank">새창</option>
                          </select>
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="modal-footer flex_center">
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="addPopup()"
                  data-bs-dismiss="modal"
                >
                  등록
                </button>
                <button
                  type="button"
                  class="btn btn-danger"
                  @click="delPopup()"
                  v-if="selPopup.id"
                  data-bs-dismiss="modal"
                >
                  삭제
                </button>
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  닫기
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <Tree
    :key="$route.path"
    :tree-data="this.$root.businesses"
    :selectable="['ENTERPRISE', 'CLASS']"
    render-button
    :callback="selectedBiz"
    multiple
    :selectedNodes="selPopup.selBiz"
    ref="biz"
  />
</template>

<style></style>

<script>
// @ is an alias to /src

import Tree from "../components/Tree";
import treeBtn from "../components/treeBtn";
import QueryGrid from "../components/QueryGrid";
import axios from "axios";
export default {
  name: "Home",
  components: {
    Tree,
    treeBtn,
    QueryGrid,
  },
  mounted() {},
  methods: {
    addPopup() {
      axios({
        method: this.selPopup.id ? "patch" : "post",
        url: "/popups" + (this.selPopup.id ? "/" + this.selPopup.id : ""),
        data: this.selPopup,
        headers: {
          "Content-Type": "application/json",
        },
      }).then((response) => {
        if (response.data.error) {
          $.notify(
            {
              // options
              message: "데이터를 조회할 수 없습니다. " + response.data.error,
            },
            {
              // settings
              type: "danger",
              z_index: 9999,
            }
          );
        } else {
          $.notify(
            {
              // options
              message: "처리되었습니다",
            },
            {
              // settings
              type: "success",
              z_index: 9999,
            }
          );
          this.$refs.qg.search();
        }
      });
    },
    delPopup() {
      axios({
        method: "delete",
        url: "/popups/" + this.selPopup.id,
        headers: {
          "Content-Type": "application/json",
        },
      }).then((response) => {
        if (response.data.error) {
          $.notify(
            {
              // options
              message: "데이터를 조회할 수 없습니다. " + response.data.error,
            },
            {
              // settings
              type: "danger",
              z_index: 9999,
            }
          );
        } else {
          $.notify(
            {
              // options
              message: "처리되었습니다",
            },
            {
              // settings
              type: "success",
              z_index: 9999,
            }
          );
          this.$refs.qg.search();
        }
      });
    },
    loadPopup(id) {
      axios({
        method: "get",
        url: "/popups/" + id,
      }).then((response) => {
        if (response.data.error) {
          $.notify(
            {
              // options
              message: "데이터를 조회할 수 없습니다. " + response.data.error,
            },
            {
              // settings
              type: "danger",
              z_index: 9999,
            }
          );
        } else {
          this.selPopup = response.data.result;
          this.selPopup.show_in_pchome =
            response.data.result.show_in_pchome == "1";
          this.selPopup.show_in_mobilehome =
            response.data.result.show_in_mobilehome == "1";
          this.selPopup.show_in_study =
            response.data.result.show_in_study == "1";
          this.selPopup.show_in_usersite =
            response.data.result.show_in_usersite == "1";
          this.selPopup.show_in_intro =
            response.data.result.show_in_intro == "1";
            this.selPopup.show_in_lms =
            response.data.result.show_in_lms == "1";
          this.selPopup.active = response.data.result.active == "1";
        }
      });
    },
    uploadImage() {
      var input = document.createElement("input");
      input.type = "file";
      input.accept = "image/*";

      input.onchange = (e) => {
        const uploadFile = e.target.files[0];
        const formData = new FormData();
        formData.append("userfile", uploadFile);

        axios({
          method: "post",
          url: "https://s.mypathkr.com/upload",
          data: formData,
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }).then((response) => {
          if (response.data.error) {
            $.notify(
              {
                // options
                message: "데이터를 조회할 수 없습니다. " + response.data.error,
              },
              {
                // settings
                type: "danger",
                z_index: 9999,
              }
            );
          } else {
            this.selPopup.image_url = response.data.url;
          }
        });
      };

      input.click();
    },
    creating() {
      this.selPopup = {
        title: "",
        show_in_pchome: false,
        show_in_mobilehome: false,
        show_in_usersite: false,
        show_in_study: false,
        show_in_intro: false,
        show_in_lms: false,
        biz_ids: [],
        size_width: "",
        size_height: "",
        start_date: "0000-00-00T00:00:00",
        end_date: "0000-00-00T00:00:00",
        active: true,
        image_url: "",
        link_href: "",
        m_link_href: "",
        target: "",
        m_target: "",
      };
    },
  },
  data() {
    return {
      records: [],
      selPopup: {
        title: "",
        show_in_pchome: false,
        show_in_mobilehome: false,
        show_in_usersite: false,
        show_in_study: false,
        show_in_intro: false,
        show_in_lms: false,
        biz_ids: [],
        size_width: "",
        size_height: "",
        start_date: "0000-00-00T00:00:00",
        end_date: "0000-00-00T00:00:00",
        active: true,
        image_url: "",
        link_href: "",
        m_link_href: "",
        target: "",
        m_target: "",
      },
      config: {
        name: "팝업",
        req_endpoint: "/popups",
        default_limit: 20,
        search_fields: [
          {
            id: "businesses",
            name: "표시대상",
            type: "business", // business, date, datetime,
          },
          {
            id: "show_filter",
            name: "표시위치",
            type: "switch",
            filter_type: {
              pchome: "PC홈페이지",
              mobilehome: "모바일홈페이지",
              usersite: "학원홈페이지",
              study: "학습관",
              intro: "인트로",
              lms: "LMS",
            },
          },

          {
            id: "date_filter",
            name: "날짜검색",
            type: "date",
            filter_type: {
              created_at: "작성일",
              start_date: "시작일",
              end_date: "종료일",
              updated_at: "수정일",
            },
          },

          {
            id: "active",
            name: "사용",
            type: "switch",
            filter_type: {
              true: "사용",
              false: "미사용",
            },
          },
          {
            id: "target",
            name: "대상",
            type: "switch",
            filter_type: {
              current: "현재 창",
              _blank: "새 탭",
            },
          },
          {
            id: "search",
            name: "키워드검색",
            type: "text",
            placeholder: "제목/링크",
          },
        ],
        columns: [
          {
            id: "id",
            sortable: true,
            name: "#",
            excel_print: (v) => {
              return v.id;
            },
          },
          {
            id: "title",
            sortable: true,
            name: "제목",
            excel_print: (v) => {
              return v.title;
            },
          },
          {
            id: "title",
            name: "표시위치",
            excel_print: (v) => {
              return "";
            },
          },
          {
            id: "width",
            sortable: true,
            name: "가로",
            excel_print: (v) => {
              return v.width;
            },
          },
          {
            id: "height",
            sortable: true,
            name: "세로",
            excel_print: (v) => {
              return v.height;
            },
          },
          {
            id: "start_date",
            sortable: true,
            name: "시작일",
            excel_print: (v) => {
              return v.start_date;
            },
          },
          {
            id: "end_date",
            sortable: true,
            name: "종료일",
            excel_print: (v) => {
              return v.end_date;
            },
          },
          {
            id: "active",
            sortable: true,
            name: "사용여부",
            excel_print: (v) => {
              return v.active;
            },
          },
          {
            id: "target",
            name: "표시방법",
            sortable: true,
            excel_print: (v) => {
              return v.target;
            },
          },
          {
            id: "created_at",
            name: "생성일",
            sortable: true,
            excel_print: (v) => {
              return v.created_at;
            },
          },
          {
            id: "act",
            name: "액션",
          },
        ],
      },
    };
  },
};
</script>
